import { constructQuery } from '~/repository/config/constructQuery'

export default (clientHttp, apiVersion) => ({
  get(params) {
    const query = constructQuery(params)

    return clientHttp.get(`${apiVersion}/ids/house_periods${query}`)
  },
})
